var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content py-5"},[_c('div',{staticClass:"container"},[_c('projects-list',{attrs:{"head_title":""}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }